import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/subcorridas`, options).then(response => {
    return {
      list: response.data.data, 
      meta: response.data.meta
    };
  });
}

function crearToken(canal) {
  const payload = {
    data: canal
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/crearTokenVenta`, payload, options)
    .then(response => {
      return response.data;
    });
}

function autorizacion(auth) {
  const payload = {
    data: auth,
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/solicitarAutorizacion`, payload, options)
    .then(response => {
      return response.data;
    });
}

function autorizacionToken(auth) {
  const payload = {
    data: auth,
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/solicitarAutorizacionConToken`, payload, options)
    .then(response => {
      return response.data;
    });
}

function verificacion(permiso) {
  const payload = {
    data: permiso,
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/verificarPermiso`, payload, options)
    .then(response => {
      return response.data;
    });
}

function bloquear(asiento) {
  const payload = {
    data: asiento,
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/bloquearAsiento`, payload, options)
    .then(response => {
      return response.data;
    });
}

function seleccionar(asiento) {
  const payload = {
    data: asiento
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/seleccionarAsiento`, payload, options)
    .then(response => {
      return response.data;
    });
}

function update(corrida) {
  const payload = jsona.serialize({
    stuff: corrida,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .patch(`${url}/subcorridas/${corrida.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function add(venta) {
  const payload = jsona.serialize({
    stuff: venta,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/venta`, payload, options)
    .then(response => {
      return response.data;
    });
}

function actualizarToken(asiento) {
  const payload = {
    data: asiento
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .put(`${url}/refrescarTokenVenta`, payload, options)
    .then(response => {
      return response.data;
    });
}

export default {
  list,
  crearToken,
  autorizacion,
  autorizacionToken,
  verificacion,
  bloquear,
  seleccionar,
  update,
  add,
  actualizarToken
};
